/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type CountPerHealthStatus = {
    count: number;
    healthStatus: CountPerHealthStatus.healthStatus;
};

export namespace CountPerHealthStatus {

    export enum healthStatus {
        CRITICAL = 'CRITICAL',
        AT_RISK = 'AT_RISK',
        HEALTHY = 'HEALTHY',
        UNMONITORED = 'UNMONITORED',
        NOT_SUPPORTED = 'NOT_SUPPORTED',
        MISSING = 'MISSING',
    }


}
